import styled from "styled-components"

import { spacing, Text } from "@minuthq/meatball-ui-react"

import { useTranslate } from "src/i18n/useTranslate"
import { Routes } from "src/router/routes"
import { IBreadcrumb } from "src/ui/Breadcrumbs/Breadcrumbs"
import { BreadcrumbView } from "src/ui/Layout/BreadcrumbView"

import { PortfolioAnalyticsIntegrationsStatus } from "./IntegrationStatus/PortfolioAnalyticsIntegrationsStatus"
import { PortfolioAnalyticsDeviceStatusGraph } from "./PortfolioAnalyticsDeviceStatusGraph"
import { PortfolioAnalyticsSummaryCard } from "./PortfolioAnalyticsSummaryCard"
import { PortfolioAnalyticsTipsCard } from "./PortfolioAnalyticsTipsCard"
import { PortfolioAnalyticsWifiHealthGraph } from "./PortfolioAnalyticsWifiHealthGraph"

export function PortfolioAnalytics() {
  const { t, langKeys, tPlaceholder } = useTranslate()

  const breadcrumbs: IBreadcrumb[] = [
    { label: t(langKeys.report_plural), to: Routes.Reports.location() },
    {
      label: tPlaceholder("Portfolio Analytics"),
      to: Routes.PortfolioAnalytics.location(),
    },
  ]

  return (
    <BreadcrumbView
      breadcrumbs={breadcrumbs}
      title={
        <Text variant="heading1">{tPlaceholder("Portfolio Analytics")}</Text>
      }
    >
      <GridContainer>
        <PortfolioAnalyticsSummaryCard />
        <TwoColumnGridWrapper>
          <PortfolioAnalyticsDeviceStatusGraph />
          <PortfolioAnalyticsWifiHealthGraph />
        </TwoColumnGridWrapper>
        <PortfolioAnalyticsIntegrationsStatus />
        <PortfolioAnalyticsTipsCard />
      </GridContainer>
    </BreadcrumbView>
  )
}

const GridContainer = styled.div`
  display: grid;
  gap: ${spacing.L};
  padding: ${spacing.L};
`

const TwoColumnGridWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${spacing.L};

  @container (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`
